import { Form } from '@anytag/shared-atoms';
import { SignInFormSchema } from './schema';
import { Template } from './Template';
import { SignInFormProps, SignInFormValues } from './types';

export const SignInForm = ({ onSubmit, defaultValues = { email: '', password: '' } }: SignInFormProps) => (
  <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={SignInFormSchema}>
    <Template />
  </Form.Provider>
);

export { type SignInFormValues };
